import { SET_IS_COMPARE_PRODUCTS, SET_IS_FAVORITE_PRODUCTS } from '../constants';

export const setIsFavoriteCatalogDevices = (payload) => ({
  type: SET_IS_FAVORITE_PRODUCTS,
  payload,
});

export const setIsCompareCatalogDevices = (payload) => ({
  type: SET_IS_COMPARE_PRODUCTS,
  payload,
});
